import { defaultPropertyDefinitions } from "@buildwithflux/constants";
import { BOMFormat } from "./base";
/**
 * JLCPCB BOM format
 * https://jlcpcb.com/help/article/45-Bill-of-Materials(BOM)-File-for-PCB-Assembly
 */
export class JLCPCBBOMFormat extends BOMFormat {
    static manufacturer = "JLCPCB";
    static columns = {
        Comment: (item) => item.mpn || item.specification.join(" "),
        Designator: (item) => item.designators.join(", "),
        Footprint: "package",
        "JLCPCB Part #": "dpn",
        "LCSC Part #": (item) => {
            const firstElementProps = Object.values(item.elementProperties)[0];
            return firstElementProps?.[defaultPropertyDefinitions.lcsc_dpn.label] || "";
        },
    };
}
//# sourceMappingURL=JLCPCB.js.map